import { Link } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import { aboutStats } from "../../mocks/manga";

const jsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "AboutPage",
      name: "关于妖精漫画网",
      url: "https://readdiary.github.io/about",
      description: "了解妖精漫画网的品牌故事、定位、内容原则与发展理念。",
    },
    {
      "@type": "Organization",
      name: "妖精漫画网",
      url: "https://readdiary.github.io/",
      email: "hello@yaojingmanga.com",
      description: "提供漫画阅读、收藏、下载、书单与标签整理功能的漫画管理平台。",
    },
  ],
};

const values = [
  { icon: "ri-book-open-fill", title: "阅读为先", desc: "坚持把阅读体验放在首位，目录清晰、进度同步、加载流畅，让看漫画成为一种享受。" },
  { icon: "ri-stack-fill", title: "统一管理", desc: "用收藏、书单、标签与目录整理，把散落各处的作品集中到一个地方，随时接着看。" },
  { icon: "ri-filter-3-fill", title: "找漫高效", desc: "多维标签与关键词搜索结合，按题材、状态、人气快速筛选，找漫追更不再大海捞针。" },
  { icon: "ri-heart-line", title: "真诚运营", desc: "认真对待每一位读者与创作者的反馈，持续优化功能，让好作品被更多人看见。" },
];

export default function About() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <Navbar />

      <main>
        <section className="border-b border-background-200/70 bg-background-100">
          <div className="mx-auto max-w-4xl px-4 py-10 text-center md:px-6 md:py-16">
            <nav aria-label="面包屑" className="mb-5 flex justify-center text-xs text-foreground-500">
              <Link to="/" className="hover:text-primary-600">首页</Link>
              <span className="mx-2">/</span>
              <span className="text-foreground-700">关于我们</span>
            </nav>
            <span className="inline-flex h-14 w-14 items-center justify-center rounded-3xl bg-primary-500 text-background-50">
              <i className="ri-sparkling-2-fill text-2xl" aria-hidden="true"></i>
            </span>
            <h1 className="mt-5 font-display text-3xl text-foreground-950 md:text-4xl">关于妖精漫画网</h1>
            <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              妖精漫画网是一处专注漫画阅读与收藏的整理入口。我们把阅读、收藏、下载、书单、标签与目录整理融为一体，
              帮助你统一管理喜欢的作品，按标签筛选、随时接着看，找漫追更更省心。
            </p>
          </div>
        </section>

        <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
            {aboutStats.map((s) => (
              <div key={s.label} className="rounded-2xl border border-background-200/70 bg-background-100 p-6 text-center">
                <p className="font-display text-3xl text-primary-600">{s.value}</p>
                <p className="mt-1 text-sm text-foreground-600">{s.label}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="bg-background-100">
          <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
            <h2 className="mb-8 text-center font-display text-2xl text-foreground-950 md:text-3xl">我们的理念</h2>
            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
              {values.map((v, idx) => (
                <div key={v.title} className={`rounded-2xl border border-background-200/70 p-6 ${
                  idx % 2 === 0 ? "bg-background-50" : "bg-accent-100/60"
                }`}>
                  <span className={`flex h-11 w-11 items-center justify-center rounded-xl text-xl ${
                    idx % 2 === 0 ? "bg-primary-100 text-primary-700" : "bg-accent-200 text-accent-800"
                  }`}>
                    <i className={v.icon} aria-hidden="true"></i>
                  </span>
                  <h3 className="mt-4 font-display text-lg text-foreground-950">{v.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="mx-auto max-w-4xl px-4 py-12 md:px-6 md:py-16">
          <h2 className="font-display text-2xl text-foreground-950 md:text-3xl">内容原则</h2>
          <div className="mt-6 space-y-4">
            <Principle title="作品信息准确、目录清晰" desc="严格维护每部作品的作者、状态、章节与更新信息，目录结构一目了然，避免读者迷路。" />
            <Principle title="分类标签科学、找漫高效" desc="基于题材与关键词建立多维标签体系，支持组合筛选，让「按标签筛选、追更找漫」真正好用。" />
            <Principle title="尊重创作、鼓励收藏分享" desc="鼓励读者通过书单与标签整理作品、交流口味，让优质作品在真实口碑中被更多人发现。" />
          </div>
        </section>

        <section className="bg-background-100">
          <div className="mx-auto max-w-4xl px-4 py-12 text-center md:px-6 md:py-16">
            <h2 className="font-display text-2xl text-foreground-950 md:text-3xl">联系我们</h2>
            <p className="mt-3 text-sm text-foreground-600">有建议、反馈或合作意向？欢迎随时与我们联系，我们会认真阅读每一条消息。</p>
            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <a href="mailto:hello@yaojingmanga.com" className="flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600">
                <i className="ri-mail-line text-base" aria-hidden="true"></i> hello@yaojingmanga.com
              </a>
              <Link to="/library" className="flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300/70 bg-background-50 px-7 py-3 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-200">
                <i className="ri-book-open-line text-base" aria-hidden="true"></i> 去漫画大全逛逛
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

function Principle({ title, desc }: { title: string; desc: string }) {
  return (
    <div className="flex gap-4 rounded-2xl border border-background-200/70 bg-background-50 p-5">
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-accent-100 text-lg text-accent-700">
        <i className="ri-check-double-line" aria-hidden="true"></i>
      </span>
      <div>
        <h3 className="font-medium text-foreground-950">{title}</h3>
        <p className="mt-1 text-sm leading-relaxed text-foreground-600">{desc}</p>
      </div>
    </div>
  );
}